import clsx from 'clsx';
import { Link } from 'react-router';
import { useApplicationContext } from '~/common/context';

interface LogoProps {
  className?: string;
  textClass?: string;
  id?: string;
}

const Logo = ({ className, textClass, ...rest }: LogoProps) => {
  const applicationContext = useApplicationContext();
  const logo =
    applicationContext.application.userTheme?.platformLogo?.resourcesFormat.at(
      0,
    )?.url;

  return (
    <Link
      to='/'
      className={clsx('text-decoration-none navbar-brand')}
      {...rest}
    >
      <div
        className={clsx(
          'd-flex',
          {
            'align-items-center': true,
          },
          className,
        )}
      >
        {logo && <img className='me-2' src={logo} alt='Logo' />}
      </div>
    </Link>
  );
};

export default Logo;
